import React from 'react';
import { Widget } from './index';
import Shifts from '../../components/shared-components/Shifts';
import { Card } from 'antd';

export class WidgetShifts extends Widget {
  constructor(obj = {}) {
    super(obj);
    this.value = obj.value || [];
    this.shiftTypes = obj.shiftTypes;
  }

  getComponent() {
    return () => (
      <Card title={this.title}>
        <Shifts 
          title={this.title} 
          value={this.value}
          shiftTypes={this.shiftTypes}
        />
      </Card>
    );
  }

  transformToWidget = (data) => {
    this.title = data.title;
    this.type = data.type;
    this.size = data.size;
    this.value = data.value || [];
    this.shiftTypes = data.shiftTypes;
    return this;
  }
}
